import { Box, type BoxProps } from '@chakra-ui/react';
import { type FC } from 'react';

import { type AvailableIcons } from '$/components/common/Icon';
import { MobileFilterMulti } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterMulti';
import { MobileFilterSingle } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterSingle';
import { type FilterOptionGroup } from '$/services/usecases/filter';

interface Props extends BoxProps {
  filterGroup: FilterOptionGroup;
  filterIcon?: AvailableIcons;
  onSingleFilterSelected: (filterSearchName: string) => void;
}

export const MobileFilter: FC<Props> = ({
  onSingleFilterSelected,
  filterGroup,
  filterIcon,
  ...boxProps
}) => {
  return (
    <Box {...boxProps}>
      {!filterGroup.isMultiSelect && (
        <MobileFilterSingle
          filterGroup={filterGroup}
          filterIcon={filterIcon}
          onSingleFilterSelected={onSingleFilterSelected}
        />
      )}

      {filterGroup.isMultiSelect && (
        <MobileFilterMulti filterGroup={filterGroup} />
      )}
    </Box>
  );
};
